import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

export type GameLayoutConfig = {
  availableTextWidth: number;
  boardWidth: number;
  boardHeight: number;
  paddingSm: number;
  paddingLg: number;
  paddingXlg: number;
  betPanelHeight: number;
  bettingBoxWidth: number;
  bettingBoxHeight: number;
  cardStackSpacing: number;
};

export type BoardScalingMetrics = {
  scaledOffsetX: number;
  scaleFactor: number;
};

export class GameMetricsService {
  public readonly gameLayoutConfig: GameLayoutConfig = {
    availableTextWidth: 256,
    boardWidth: 1200,
    boardHeight: 1600,
    paddingSm: 20,
    paddingLg: 50,
    paddingXlg: 70,
    betPanelHeight: 200,
    bettingBoxWidth: 256,
    bettingBoxHeight: 384,
    cardStackSpacing: 70,
  };

  public static defaultBoardScalingMetrics(): BoardScalingMetrics {
    return {
      scaledOffsetX: 0,
      scaleFactor: 1,
    };
  }

  public calculateBoardScaling(gameSizeMetrics: GameSizeMetrics): BoardScalingMetrics {
    const layoutConfig = this.gameLayoutConfig;
    const totalWidth = layoutConfig.boardWidth;
    const totalHeight = layoutConfig.boardHeight;

    const scaleFactorW = gameSizeMetrics.widthDpr / totalWidth;
    const scaleFactorH = gameSizeMetrics.heightDpr / totalHeight;

    let scaledOffsetX = 0;
    if (scaleFactorH < scaleFactorW) {
      scaledOffsetX = (totalWidth * scaleFactorW - totalWidth * scaleFactorH) * 0.5;
    }

    return {
      scaledOffsetX: scaledOffsetX,
      scaleFactor: Math.min(scaleFactorW, scaleFactorH),
    };
  }
}
